import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Form, Checkbox, Modal, Button, Spin, Icon } from "antd";
import { getPermissions, updatePermissions } from "../../../actions/AffiliateActions";

const CheckboxGroup = Checkbox.Group;

class Permissions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            indeterminate: true,
            checkedList: this.props.newAffiliatePermissions,
            noPermission: this.props.newAffiliatePermissions && this.props.newAffiliatePermissions[0] === 'None',
        }
    }

    componentDidMount() {
        if (this.props.affiliates.permissions.length && !this.props.newAffiliatePermissions) {
            this.setState({
                checkedList: this.props.affiliates.permissions,
                noPermission: this.props.affiliates.permissions[0] === 'None'
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.affiliates.permissions.length && this.props.affiliates.permissions.length) {
            this.setState({
                checkedList: this.props.affiliates.permissions,
                noPermission: this.props.affiliates.permissions[0]  === 'None'
            });
        }
    }

    showPermissionsModal = () => {
        const affiliateId = this.props.affId;

        this.props.dispatch(getPermissions(affiliateId, false));

        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
            checkedList: []
        });

    };

    noPermission = () => {
        this.setState({
            checkedList: ["None"],
            noPermission: true,
        });

        this.props.onPermissionsChange && this.props.onPermissionsChange(['None']);
    };

    onChangeAddAffiliate = checkedList => {
        this.setState({
            checkedList,
            noPermission: false,
        });

        if (checkedList.length) {
            this.props.onPermissionsChange(checkedList);
        } else {
            this.noPermission();
        }
    };

    handleSubmit = () => {

        const updatePermissionsData = {
            AffiliateId: this.props.affId,
            Permissions: this.state.checkedList
        };

        this.props.dispatch(updatePermissions(updatePermissionsData, this.props.intl)).then(
            () => {
                if (!this.props.affiliates.permissions.error) {
                    this.setState({
                        visible: false
                    });
                }
            })
    };

    render() {
        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        const options = [
            { label: this.props.intl.messages.add_remove_domains, value: 'AddRemoveDomain' },
            { label: this.props.intl.messages.change_design, value: 'ChangeDesign' },
            { label: this.props.intl.messages.topup_players, value: 'TopupPlayers' },
            { label: this.props.intl.messages.reports, value: 'Reports' },
            { label: this.props.intl.messages.withdraw, value: 'Withdraw' },
            { label: this.props.intl.messages.view_players_email, value: 'ViewPlayersEmail' },
        ];

        let onChange = (checkedList) => {
            this.setState({
                checkedList,
                noPermission: false,
            });

            !checkedList.length && this.noPermission();
        };

        return (

            <React.Fragment>
                {this.props.affId ? <div>
                    <Button className='clear_button_style' onClick={this.showPermissionsModal}>
                        {this.props.intl.messages.permissions}
                    </Button>

                    <Modal
                        title={this.props.intl.messages.permissions}
                        visible={this.state.visible}
                        centered
                        onCancel={this.handleCancel}
                        footer={[
                            <div key='footer-buttons'>
                                <Button onClick={this.handleCancel}
                                    key="cancel">{this.props.intl.messages.cancel}</Button>
                                <Button key="save" onClick={this.handleSubmit}
                                    type="primary">{this.props.intl.messages.save}</Button>
                            </div>
                        ]}
                    >
                        <Spin indicator={antIcon} spinning={this.props.affiliates.inProcess}>
                            <div className="ta--flex ta--flex-col">
                                <Checkbox
                                    onChange={this.noPermission}
                                    checked={this.state.noPermission}
                                    className="ta--mb-17"
                                    value="None"
                                >
                                    {this.props.intl.messages.none}
                                </Checkbox>
                                <CheckboxGroup
                                    options={options}
                                    value={this.state.checkedList}
                                    onChange={onChange}
                                    className="ta--permission-checkboxGroup"
                                /></div>
                        </Spin>
                    </Modal>
                </div> : <div className="ta--flex ta--flex-col">
                        <Checkbox
                            onChange={this.noPermission}
                            checked={this.state.noPermission}
                            className="ta--mb-17"
                            value="None"
                        >
                            {this.props.intl.messages.none}
                        </Checkbox>
                        <CheckboxGroup
                            options={options}
                            value={this.state.checkedList}
                            onChange={this.onChangeAddAffiliate}
                            className="ta--permission-checkboxGroup"
                        /></div>
                }
            </React.Fragment>

        );
    }
}

const mapStateToProps = state => {
    return {
        affiliates: state.affiliates
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(Permissions)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Affiliates/Permissions.js